import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlayerIconBorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800.2",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 800,
		height: 800.2,
		style: { fill: "#fff" }
	}), /* @__PURE__ */ _jsx("g", {
		id: "b",
		"data-name": "Layer 3",
		fill: "currentColor",
		children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", { points: "600 500.2 600 450.2 500 350.2 300 350.2 300 300.2 530 300.2 600 370.2 600 200.2 200 200.2 200 350.2 300 450.2 500 450.2 500 500.2 270 500.2 200 430.2 200 600.2 600 600.2 600 500.2" }), /* @__PURE__ */ _jsx("path", { d: "m50,50.2v700h700V50.2H50Zm600,600H150V150.2h500v500Z" })] })
	})]
});
export default SvgSlayerIconBorder;
